
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["growers-image-curve",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"growers-image-curve","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 134.3 741.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 .1c67.6 122.4 102.6 260.6 101 400.1-1.3 117.7-28.7 234.5-80 340.9 37.7.3 75.3-.3 113 0-1-247 1-494 0-741C90.3.4 43.7-.2 0 .1z"}})])
          )
        }
      }
    